import React from 'react';
import { View } from 'react-native';

const RefreshIcon = ({ size = 24, color = '#000', style = {} }) => {
  const strokeWidth = Math.max(1, size / 12);
  
  return (
    <View style={style}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M1 4V10H7" 
          stroke={color} 
          strokeWidth={strokeWidth} 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M23 20V14H17" 
          stroke={color} 
          strokeWidth={strokeWidth} 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M20.49 9.00002C19.9828 7.56671 19.1209 6.28342 17.9845 5.27502C16.8482 4.26661 15.4745 3.56679 14 3.24002C12.5255 2.91325 10.9998 2.97788 9.5491 3.42921C8.09844 3.88053 6.78671 4.70094 5.73999 5.80002L1 10M23 14L18.26 18.2C17.2133 19.2991 15.9016 20.1195 14.4509 20.5708C13.0002 21.0221 11.4745 21.0868 10 20.76C8.52548 20.4333 7.15181 19.7334 6.01547 18.725C4.87913 17.7166 4.01717 16.4333 3.50999 15" 
          stroke={color} 
          strokeWidth={strokeWidth} 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </View>
  );
};

export default RefreshIcon;
